import { useState, useEffect } from "react";
import DistributorNavbar from "./DistributorComp/DistributorNavbar";
import DataTable from "react-data-table-component";
import DistributorReportNavbar from "./DistributorComp/DistributorReportNavbar";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import axios from "axios";
import { baseurl } from "../../component/Baseurl";
import Swal from "sweetalert2";
import * as XLSX from "xlsx"; // Import xlsx for Excel export
import { Link } from "react-router-dom";

function DistributorWallet() {
  const [filterText, setFilterText] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);  
//   const [walletBalance, setwalletBalance] = useState([]);  
  const [isFetching, setIsFetching] = useState(true);

  const distributorId = localStorage.getItem("distributor_id");
  const [walletBalance, setwalletBalance] = useState([]);  
  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const response = await axios.get(`${baseurl}GetWalletTransactions/${distributorId}`);
        setTransactions(response.data.transactions || []);
        setwalletBalance(response.data.wallet_balance || []);
      } catch (error) {
        console.error("Error fetching transactions:", error);
        setTransactions([]);
      }
      setIsFetching(false);
    };

    fetchTransactions();
  }, [distributorId]);

  // Columns for the DataTable
  const columns = [
    { name: "Sr. No.", selector: (row, index) => index + 1, sortable: false, width: "80px" },
    { name: "Amount", selector: (row) => `₹${row.amount}`, sortable: true },
    { name: "Transaction Type", selector: (row) => row.transaction_type, sortable: true },
    {
        name: "Transaction Detail",
        selector: (row) => row.transaction_reason,
        sortable: true,
        cell: (row) => (
          <div className="reason-column text-start">{row.transaction_reason}</div>
        ),
        width: "300px",
      },
    { name: "Date", selector: (row) => new Date(row.created_at).toLocaleDateString(), sortable: true },
  ];

  const filteredTransactions = transactions.filter(
    (transaction) =>
      transaction.transaction_reason.toLowerCase().includes(filterText.toLowerCase()) ||
      transaction.transaction_type.toLowerCase().includes(filterText.toLowerCase())
  );

  const handleShow = () => setShowModal(true);
  const handleClose = () => {
    setShowModal(false);
    setAmount("");
  };

  const handleSubmitAmount = async () => {
    if (!amount || isNaN(amount) || amount <= 0) {
      alert("Please enter a valid amount");
      return;
    }

    setLoading(true);

    const requestData = {
      user_id: distributorId,
      user_type: "state_head",
      amount: amount,
      transaction_reason: `Wallet Top-Up by Distributor ${distributorId}`,
    };

    try {
      const response = await axios.post(`${baseurl}AddToWallet`, requestData);

      if (response.data.message === "Wallet updated successfully!") {
        Swal.fire({
          title: "Success!",
          text: response.data.transaction_reason,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "Failed!",
          text: "Failed to add amount.",
          icon: "error",
          confirmButtonText: "Try Again",
        });
      }
    } catch (error) {
      console.error("Error adding amount:", error);
      Swal.fire({
        title: "Error!",
        text: "Error adding amount. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }

    setLoading(false);
    window.location.reload();
    handleClose();
  };

  // 📥 Function to Export DataTable as Excel
  const handleDownloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(transactions.map((row, index) => ({
      "Sr. No.": index + 1,
      "Amount": row.amount,
      "Transaction Type": row.transaction_type,
      "Transaction Detail": row.transaction_reason,
      "Date": new Date(row.created_at).toLocaleDateString(),
    })));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Wallet Transactions");

    XLSX.writeFile(wb, "Wallet_Transactions.xlsx");
  };

  return (
    <>
      <DistributorNavbar />
      <div className="bgagent transaction-container">
        <div className="container-fluid">

        <div className="row g-2 mb-3">
            <div className="col-md-3">
                <div className="bg-white p-3 border rounded">
                <h2 className="title text-start">Wallet Balance</h2>
                <div className="kma2 text-start">&#8377; {walletBalance}</div>
                </div>
            </div>
        </div>

          <div className="crdmain">

            <div className="text-end d-flex justify-content-end">
              <Link to="/state-head/top-up-req"  className="mb-3 btn3" >
                Add Amount
              </Link>

              {/* 🟢 Add Download Button */}
              {/* <Button variant="success" className="mb-3 ms-2" onClick={handleDownloadExcel}>
                Download Excel
              </Button> */}
            </div>

            <div className="transaction-card">
              <h2 className="title text-start">My Wallet History</h2>

              <input
                type="text"
                className="search-box"
                placeholder="Search transactions..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />

              <DataTable
                columns={columns}
                data={filteredTransactions}
                pagination
                highlightOnHover
                striped
                noDataComponent="No transactions found"
                className="transaction-table"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Add Amount Modal */}
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Amount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label>Enter Amount:</label>
          <input
            type="number"
            className="form-control mt-2"
            placeholder="Enter amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmitAmount} disabled={loading}>
            {loading ? "Processing..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DistributorWallet;
